/** Ids of `fulfillment.return_disposition`, seeded by migration 20261105120000: the outcome of a return receipt row. */
export var ReturnDisposition;
(function (ReturnDisposition) {
    ReturnDisposition[ReturnDisposition["RESTOCK"] = 1] = "RESTOCK";
    ReturnDisposition[ReturnDisposition["QUARANTINE"] = 2] = "QUARANTINE";
    ReturnDisposition[ReturnDisposition["DESTROY"] = 3] = "DESTROY";
})(ReturnDisposition || (ReturnDisposition = {}));
//# sourceMappingURL=return-disposition.js.map